import React from 'react'
import { AmpIFrame } from '../../../publication/Embed/amp/AmpIFrame'
import { StyledContent } from '../../../publication/Embed/amp/AmpStyledContent.styled'
import { generateFrameSrc } from '../helpers/whistleout'

export interface AmpWhistleOutProps {
    link: string
}

/**
 * As per A/C 3 widgets have a height of 500, others 325, only for AMP
 */
const getHeightForWidgetType = (link: string) => {
    if (
        link.indexOf('Widgets/BroadbandProduct/Embed') > 0 ||
        link.indexOf('Widgets/Tablet/Embed') > 0 ||
        link.indexOf('Widgets/Phone/Embed') > 0
    ) {
        return 500
    }
    return 325
}

export const AmpWhistleOut: React.FC<AmpWhistleOutProps> = (props) => (
    <StyledContent>
        <AmpIFrame
            width={500}
            height={getHeightForWidgetType(props.link)}
            src={generateFrameSrc(props.link, true)}
            frameborder={0}
            layout={'responsive'}
            allowSameOrigin={true}
            allowPopups={true}
            allowForms={true}
            resizable
            noFallback={true} // need this to be set as its appearing on the iframes.
            innerHtml={() => <div overflow=""></div>}
        />
    </StyledContent>
)

AmpWhistleOut.displayName = 'AmpWhistleOut'
